<template>
  <div>
    <textarea
      :rows="input.rows || 4"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
    ></textarea>
  </div>
</template>
<script>
export default {
  name: "Textarea",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
